// ─────────────────────────────────────────────────────────────────────────────
// App configuration constants
// ─────────────────────────────────────────────────────────────────────────────

/**
 * PORTAL_URL — the canonical public URL of the MagicIntake app.
 *
 * This is the single source of truth for "where the app lives" on the client.
 * It MUST stay in sync with three things in the Supabase dashboard:
 *   • Auth → URL Configuration → Site URL
 *   • Auth → URL Configuration → Redirect URLs (allow-list — required for the
 *     password-reset `redirectTo` below to be honored)
 *   • Auth → Email Templates (the link host in the Reset Password email)
 *
 * Defaults to production. Override per-environment with VITE_PORTAL_URL — e.g.
 * set `VITE_PORTAL_URL=http://localhost:5173` in .env.local so reset links come
 * back to your machine instead of bouncing you to production while developing.
 *
 * Normalized to the ORIGIN (scheme + host, no path) so callers can safely
 * template `${PORTAL_URL}/path` exactly once. This guards against a misconfigured
 * VITE_PORTAL_URL that includes a path — e.g. the full ".../reset-password" URL,
 * which otherwise produces a doubled ".../reset-password/reset-password" link in
 * the password-reset email. Built from the env var only — never window.location.
 */
const RAW_PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'https://app.magicintake.com';
export const PORTAL_URL = (() => {
  try {
    return new URL(RAW_PORTAL_URL).origin;
  } catch {
    return 'https://app.magicintake.com';
  }
})();
